function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M90.319 27.892H80.104l-3.392-10.215H42.676l-3.392 10.215H29.069a3.394 3.394 0 00-3.392 3.392v66.67a3.394 3.394 0 003.392 3.391h61.25a3.394 3.394 0 003.392-3.392v-66.67a3.394 3.394 0 00-3.392-3.391z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.674 89.025a1.73 1.73 0 001.715-1.716 1.73 1.73 0 00-1.715-1.715c-.936 0-1.715.74-1.715 1.716.038.935.78 1.715 1.715 1.715zM59.713 77.991a1.73 1.73 0 001.715-1.716 1.73 1.73 0 00-1.715-1.715c-.936 0-1.715.74-1.715 1.715 0 .975.78 1.716 1.715 1.716zM59.713 66.997a1.73 1.73 0 001.715-1.716 1.73 1.73 0 00-1.715-1.715c-.936 0-1.715.74-1.715 1.715 0 .975.78 1.716 1.715 1.716zM59.713 56.002a1.73 1.73 0 001.715-1.716 1.73 1.73 0 00-1.715-1.715c-.936 0-1.715.74-1.715 1.715.038.975.78 1.716 1.715 1.716z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M90.319 26.215H81.35l-3.002-9.006v-.04A1.71 1.71 0 0076.751 16H42.675c-.74 0-1.364.468-1.598 1.17v.039l-3.002 9.006h-8.968c-2.807 0-5.107 2.3-5.107 5.107v66.67c0 2.807 2.3 5.107 5.107 5.107H90.32c2.807 0 5.107-2.3 5.107-5.107v-66.67a5.1 5.1 0 00-5.107-5.107zm-12.126 1.209L66.81 38.808l-4.796-7.174 13.88-11.111 2.3 6.9zm-6.316-8.032l-12.164 9.747-12.164-9.747h24.328zm-28.305 1.17l13.88 11.111-4.796 7.174-11.384-11.385 2.3-6.9zm48.423 77.43a1.73 1.73 0 01-1.715 1.715H29.068a1.73 1.73 0 01-1.715-1.715v-66.67c0-.935.78-1.715 1.715-1.715h9.513l13.1 13.1c.39.39.975.585 1.56.468l2.69-3.08 3.821-5.732 3.82 5.732 2.613 3.08a1.733 1.733 0 001.56-.468l13.1-13.1h9.474c.935 0 1.715.78 1.715 1.715v66.67h-.039z",
  fill: "#000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.111 56.002h7.252c.858 0 1.599-.624 1.755-1.443a1.696 1.696 0 00-1.677-1.949h-7.369a1.696 1.696 0 00-1.676 1.95c.078.857.858 1.442 1.715 1.442zM52.5 49.296v41.912c0 .858.624 1.599 1.443 1.755a1.696 1.696 0 001.95-1.677V49.218a1.696 1.696 0 00-1.95-1.676c-.819.117-1.442.896-1.442 1.754z",
  fill: "#000"
});

function SvgAttireBlackOnBlack(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgAttireBlackOnBlack;